module.exports = __webpack_public_path__ + "img/banner2_9_jp.510a01fb.png";